import { AnalyticsStoreState } from './state';

import * as Analytics from './types';
import { normalize } from 'normalizr';
import { videoLikeDislike } from '../../utils/schema';

export default function notification(state = AnalyticsStoreState, action: any) {

  switch (action.type) {
    case Analytics.ANALYTICS:
      return {
        ...state,
        ...action.payload
      };

    case Analytics.ANALYTICS_ERROR:
      return {
        ...state,
        ...action.payload
      };

    case Analytics.ANALYTICS_STUDENTS:
      return {
        ...state,
        ...action.payload
      };

    case Analytics.ANAYLTICS_LIKE:
      const analyticLikeNormalize = normalize(action.payload, [videoLikeDislike]);

      return {
        ...state,
        videoLikeDislike: analyticLikeNormalize.entities.videoLikeDislike || {}
      };

    case Analytics.UPDATE_ANAYLTICS_LIKE:
      const updateAnalyticLikeNormalize = normalize([action.payload], [videoLikeDislike]);

      return {
        ...state,
        videoLikeDislike: { ...state.videoLikeDislike, ...updateAnalyticLikeNormalize.entities.videoLikeDislike }
      };

    default:
      return state;
  }
}
